import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import IraAccount from "../ira_acc_info/IraAccount";

function IraAccLanding() {
    return (
        <div className="custodial_landing">
            <Header/>
            <IraAccount/>
            <Footer/>
        </div>
    )
}

export default IraAccLanding